import React from "react";
import useWindowDimensions from "hooks/Dimensions";

export default function ContactUsHeader(){
    const {isMobile} = useWindowDimensions();
    return(<h2 style={{color: isMobile?'#008A00':'#FFFFFF'}} className="mr-auto text-nowrap">Contact Us</h2>)
}
